import { TYPE } from '../Core.constants';

export const getClub = ({ config = {}, type, urlParams = {} } = {}) => {
  let {
    accomodation: {
      club: { authentication, discount: discountEnabled = false, id, name, rates = false, url = {} } = {},
      variants = [],
    } = {},
  } = config;
  let active = !!id;
  if (!active) return;

  const { applyClubDiscount, idtokenprovider: idHotel = '' } = urlParams;
  let discount = applyClubDiscount ? applyClubDiscount === 'true' : undefined;

  const nextVariants = variants.map(({ club, id } = {}) => {
    if (club && Object.keys(club).length === 0) return { active: false, id };

    const { discount: variantDiscount, rates: variantRates } = club || {};

    return {
      active: true,
      discount:
        variantDiscount !== undefined
          ? variantRates !== undefined
            ? variantRates
              ? variantDiscount
              : undefined
            : rates
            ? variantDiscount
            : undefined
          : variantRates ?? rates
          ? discountEnabled
          : undefined,
      discountEnabled: variantRates ?? rates,
      id,
    };
  });

  if (type === TYPE.CHAIN) {
    const variant = nextVariants.find(({ id = '' } = {}) => id.toString() === idHotel.toString());
    if (variant) {
      const { active: variantActive, discount: variantDiscount, discountEnabled: variantDiscountEnabled } = variant;
      active = variantActive;
      discount = discount ?? variantDiscount;
      discountEnabled = variantDiscountEnabled;
    }
  }
  discount = discount ?? discountEnabled;

  return {
    active,
    authentication,
    discount: active && rates ? discount : undefined,
    id,
    name,
    url,
    variants: nextVariants,
  };
};
